import styled from '@emotion/styled';
import Iphone from '../../../images/iPhone-13-Pro-Front.png';
import { ReactComponent as WarnIcon } from '../../../images/warning.svg';
import { ReactComponent as BagIcon } from '../../../images/bag.svg';
import { ReactComponent as CellularIcon } from '../../../images/Cellular Connection.svg';
import { ReactComponent as WifiIcon } from '../../../images/Wifi.svg';
import { ReactComponent as BatteryIcon } from '../../../images/Battery.svg';
import { ReactComponent as BasketIcon } from '../../../images/basket.svg';
import { ReactComponent as BackIcon } from '../../../images/arrow/left2.svg';
import { ReactComponent as ShareIcon } from '../../../images/share-2.svg';
import { ReactComponent as HeartIcon } from '../../../images/heart.svg';
import { ReactComponent as DirectIcon } from '../../../images/directions.svg';
import { Delete } from '@mui/icons-material';


export const IconBag = styled(BagIcon)`
  width: 16px;
  height: 16px;
 
  stroke: var(--colors-primary-600);

`;

export const IconWarn = styled(WarnIcon)`
  width: 16px;
  height: 16px;
 
  stroke: var(--colors-warning-600);

`;


export const IconBasket = styled(BasketIcon)`
  width: 16px;
  height: 16px;
  stroke: var(--colors-grey-600);

`;

export const IconDirect = styled(DirectIcon)`
  width: 16px;
  height: 16px;
  
  

`;

export const IconHeart = styled(HeartIcon)`
  width: 24px;
  height: 24px;
  
  

`;
export const IconShare = styled(ShareIcon)`
  width: 24px;
  height: 24px;

`;

export const IconBack = styled(BackIcon)`
  width: 24px;
  height: 24px;
  stroke: var(--colors-grey-25);

`;
export const IconBattery = styled(BatteryIcon)`
  width: 20px;
  height: 12px;

  

`;
export const IconWifi = styled(WifiIcon)`
  width: 16px;
  height: 12px;
  

`;
export const IconCellular = styled(CellularIcon)`
  width: 16px;
  height: 12px;

  

`;


export const ButtonWrap = styled.div`

display: flex;
align-items: center;
justify-content: space-between;
gap:12px;
width:100%;
@media (max-width: 689px) {
 
flex-direction: column;
  
  } 


`;

export const PreviewBox = styled.div`
position: relative;
width: 240px;
height: 516px;
margin: 24px 59px 0 59px;
background: var(--colors-grey-50);

&::after{
  display: block;
  width: 267px;
height: 544px;
  position: absolute;
  top: -14px;
  left:-13px;
  background-image: url(${Iphone});
  background-position: top;
  background-size: contain;
  background-repeat: no-repeat;
  content: "";
}
  @media (max-width: 689px) {
margin: 24px auto;
margin-bottom: 0;
  } 
  `;

export const PreviewImgBox = styled.div`
border-radius: 16px;
border-radius:16px;
 height: 134px;
 width: 240px;
 position: relative;

`;

export const PreviewBagsImg = styled.img`
object-fit: cover;
border-radius: 16px;
border-radius:16px;
 height: 100%;
 width: 100%;

`;



export const PreviewImgTopBox = styled.div`
top:0px;
right:0px;
 height: auto;
 width: 100%;
 position: absolute;
 display: flex;
 justify-content: space-between;
 align-items: center;
 padding:5px 10px ;
`;


export const Times = styled.span`
font-family: var(--second-family);
font-weight: 590;
font-size: 14px;
line-height: 129%;
text-align: center;
color: var(--colors-grey-25);
`;

export const IphoneIconsBox = styled.div`
display: flex;
align-items: center;
justify-content: center;
gap: 4px;

`;


export const PreviewImgMiddleBox = styled.div`
top:20px;
right:0px;
 height: auto;
 width: 100%;
 position: absolute;
 display: flex;
 justify-content: space-between;
 align-items: center;
 padding:10px ;
`;
export const ShareBox = styled.div`

 height: auto;
 width: auto;

 display: flex;
 align-items: center;
 gap:12px ;
`;


export const PreviewImgBottomBox = styled.div`
bottom:0px;
right:0px;
 height: auto;
 width: 100%;
 position: absolute;
 display: flex;
 justify-content: space-between;
 align-items: center;
 padding:10px ;
`;


export const PreviewBagsName = styled.p`

 height: auto;
font-family: var(--font-family);
font-weight: 600;
font-size: 14px;
line-height: 135%;
color: var(--colors-grey-25);
 padding:0px ;
 white-space:normal;
 width:130px;
word-wrap: break-word; /* Старий варіант */
overflow-wrap: break-word; /* Новий стандарт */
`;

export const PreviewBagsCount = styled.p`
align-self:self-end;
  white-space: nowrap;
border-radius: 360px;
padding: 4px 12px;
width: auto;
height: 20px;
display: flex;
align-items: center;
justify-content: center;
background: var(--colors-secondary-600);;
font-family: var(--font-family);
font-weight: 400;
font-size: 11px;
line-height: 150%;
color: var(--colors-grey-25);


`;

export const PreviewBottomBox = styled.div`
position: absolute;
bottom: 0;
border-top-left-radius: 16px;
border-top-right-radius: 16px;
padding: 8px;
width:100%;
background: var(--colors-grey-25);
  `;
export const PreviewButton = styled.div`
margin: 0 auto;
border-radius: 360px;
padding: 2px 4px;
width: 100%;
height: 28px;
display: flex;
align-items: center;
justify-content: center;
font-family: var(--font-family);
font-weight: 500;
font-size: 12px;
line-height: 100%;
text-align: center;
color: var(--colors-grey-25);
margin-bottom: 20px;
background: var(--colors-primary-600);
  `;



export const PreviewInfoBox = styled.ul`
margin: 0 auto;
margin-top: 10px;
border-radius: 16px;
padding: 8px;
width: 220px;
max-height: 300px;
 overflow-y:auto;
background: var(--colors-grey-25);
position: relative;
z-index: 100000;
  `;
export const PreviewInfoRow = styled.li`
width: 100%;
&:nth-of-type(1){

  margin-bottom: 8px;
}
&:nth-of-type(2){
  padding: 4px 0px;
  display: flex;
  align-items: center;
  gap:10px;
  border-bottom: 1px solid var(--colors-grey-100);
border-top: 1px solid var(--colors-grey-100);
  margin-bottom: 6px;
}
&:nth-of-type(3){
  display: flex;
  align-items: start;
flex-direction: column;
  height: fit-content;
   margin-bottom: 6px;
}
&:nth-of-type(4){
   padding: 4px 0px;
border-top: 1px solid var(--colors-grey-100);
display: flex;
flex-direction: column;
gap: 4px;

   margin-bottom: 6px;
}

&:nth-of-type(5){
   padding: 4px 0px;
 border-top: 1px solid var(--colors-grey-100);

}
  `;
export const PreviewInfoSubBox = styled.div`
width: 100%;
display: flex;
gap: 4px;
align-items: center;
font-family: var(--font-family);
font-weight: 500;
font-size: 10px;
line-height: 120%;
color: var(--colors-grey-800);
  `;



export const PreviewInfoSubRow = styled.div`
width: 100%;
display: flex;
justify-content: space-between;
align-items: center;
  `;
export const Distance = styled.p`
width: fit-content;
display: flex;
gap:4px;
align-items: center;
font-family: var(--font-family);
font-weight: 500;
font-size: 12px;
line-height: 150%;
color: var(--colors-grey-800);
  `;

export const TimeS = styled.p`
width: fit-content;
display: flex;
gap:4px;
align-items: center;
font-family: var(--font-family);
font-weight: 500;
font-size: 10px;
line-height: 150%;
color: var(--colors-grey-500);
  `;





export const BagOldCost = styled.p`

font-family: var(--font-family);
font-weight: 500;
font-size: 12px;
line-height: 137%;
text-decoration: line-through;
text-align: right;
color: var(--colors-grey-400);
  `;

export const BagCost = styled.p`

font-family: var(--font-family);
font-weight: 700;
font-size: 14px;
line-height: 135%;
text-align: right;
color: var(--colors-grey-900);
  `;

export const PreviewLogoBox = styled.div`
border-radius: 360px;
width: 34px;
height: 34px;
min-width: 34px;
min-height: 34px;
  `;

export const PreviewLogoImg = styled.img`
border-radius: 360px;
object-fit: cover;
object-position: center;
width: 34px;
height: 34px;
min-width: 34px;
min-height: 34px;
  `;
export const PreviewPointBox = styled.div`
display: flex;
flex-direction: column;
width: calc(100% - 40px);
  `;
export const PreviewPointName = styled.p`
font-family: var(--font-family);
font-weight: 600;
font-size: 12px;
line-height: 137%;
color: var(--colors-grey-800);
  `;
export const PreviewPointAddress = styled.p`
font-family: var(--font-family);
font-weight: 500;
font-size: 10px;
line-height: 120%;
color: var(--colors-grey-500);
  `;


export const PreviewDescLabel = styled.p`
font-family: var(--font-family);
font-weight: 500;
font-size: 10px;
line-height: 120%;
color: var(--colors-grey-500);
margin-bottom: 4px;
  `;

export const PreviewDesc = styled.p`
font-family: var(--font-family);
font-weight: 500;
font-size: 11px;
line-height: 117%;
color: var(--colors-grey-800);
margin-bottom: 6px;
/* max-height: 24px; */

  `;



export const PreviewCategory = styled.ul`
display: flex;
flex-direction: row;
flex-wrap: wrap;
gap:2px;
align-items: start;
  `;

export const PreviewCategoryItem = styled.li`
border: 1px solid var(--colors-secondary-300);
border-radius: 360px;
padding: 1px 8px;
width: fit-content;
height: 20px;
display: flex;align-items: center;
justify-content: center;
background: var(--colors-secondary-50);
font-family: var(--font-family);
font-weight: 600;
font-size: 10px;
line-height: 137%;
color: var(--colors-secondary-600);
  `;


export const ModalBox = styled.div`
width:646px;
margin: 24px 0;
  @media (max-width: 689px) {
width: 100%;
  } 
  `;
export const ModalTitle = styled.h2`
font-family: var(--font-family);
font-weight: 600;
font-size: 20px;
line-height: 135%;
text-align: center;
color: var(--colors-grey-900);
width:100%;
margin-top: 8px;
`;



export const CancelButton = styled.button`
font-family: var(--font-family);
font-weight: 600;
font-size: 16px;
line-height: 137%;
height:48px;
text-align: center;
width:calc((100% - 12px) / 2);
cursor: pointer;
display: flex;
align-items: center;
color: var(--colors-primary-600);
background:none;
border: 1px solid var(--colors-primary-600);
border-radius: 360px;
padding: 8px 12px;
justify-content: center;
@media (max-width: 689px) {
 
  width: 100%;
  
  } 
`;

export const SaveButton = styled.button`
font-family: var(--font-family);
font-weight: 600;
font-size: 16px;
line-height: 137%;
height:48px;
text-align: center;
color: var(--colors-grey-25);
display: flex;
justify-content: center;
width:calc((100% - 12px) / 2);
align-items: center;
background: var(--colors-primary-600);
border-radius: 360px;
padding: 8px 12px;
cursor: pointer;
@media (max-width: 689px) {
 
  width: 100%;
  
  } 

`;

export const Img = styled.img`

object-fit: contain;
border-radius: 40px;
margin-top: 10px;
width: 386px;
height: 184px;
margin-bottom: 16px;
@media (max-width: 689px) {
 
  width: 100%;
  margin-bottom: 0;
  
  } 
`;
export const Title = styled.h2`
font-family: var(--font-family);
font-weight: 600;
font-size: 20px;
line-height: 135%;
text-align: center;
color: var(--colors-grey-900);
margin-bottom: 4px;
`;

export const Text = styled.p`
font-family: var(--font-family);
font-weight: 500;
font-size: 16px;
line-height: 137%;
text-align: center;
color: var(--colors-grey-600);
margin-bottom: 24px;
`;
export const WrapButton = styled.div`
display: flex;
gap: 12px;
width: 100%;
flex-direction:row-reverse;
@media (max-width: 689px) {
 
 flex-direction:column;
  
  } 

`;

export const YesButton = styled.button`
cursor: pointer;
border: 1px solid var(--colors-error-600);
border-radius: 360px;
padding: 8px 12px;
width: 187px;
height: 48px;
display: flex;
align-items: center;
justify-content: center;
font-family: var(--font-family);
font-weight: 600;
font-size: 16px;
line-height: 137%;
text-align: center;
color: var(--colors-error-600);
background: none;
@media (max-width: 689px) {
 
  width: 100%;
  
  } 
`;

export const NoButton = styled.button`
cursor: pointer;
border-radius: 360px;
padding: 8px 12px;
width: 187px;
height: 48px;
display: flex;
align-items: center;
justify-content: center;
background: var(--colors-primary-600);
font-family: var(--font-family);
font-weight: 600;
font-size: 16px;
line-height: 137%;
text-align: center;
color: var(--colors-grey-25);
@media (max-width: 689px) {
 
  width: 100%;
  
  } 
`;


export const AllModalBox = styled.div`
width:386px;

@media (max-width: 689px) {
 
  width: 100%;
  
  } 

`;